module.exports = __webpack_public_path__ + "static/img/bg.e6a526a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/bg.png
// module id = /L4j
// module chunks = 1